import { combineReducers } from 'redux'
import userReducer from './user/reducer'

import commboardReducer from './commboard/reducer'
import groupReducer from './Group/reducer'
import courseReducer from './Course/reducer'
import quizReducer from './Quiz/reducer'
import storeReducer from './Stores/reducer'
import roleReducer from './Role/reducer'
import usersReducer from './Users/reducer'
import LearningPlanReducer from './LearningPlan/reducer'
import managerReportReducer from './ManagerReport/reducer'
import languageReducer from './ConfigurationSettings/LanguageConfig/reducer'
import employeeReportReducer from './EmployeeReport/reducer'
import locationReducer from './Location/reducer'
import roleGroupsReducer from './RoleGroup/reducer'
import orgGroupsReducer from './OrgGroup/reducer'
import generalConfigReducer from './ConfigurationSettings/GeneralConfig/reducer'
import courseConfigReducer from './ConfigurationSettings/CourseConfig/reducer'
import languageConfigReducer from './ConfigurationSettings/LanguageConfig/reducer'
import themeConfigReducer from './ConfigurationSettings/ThemeConfig/reducer'
import questionBankReducer from './QuestionBank/reducer'
import externalReportsReducer from './ExternalReports/reducer'
import checkListReducer from './Checklist/reducer'
import libraryReducer from './Library/reducer'
import rewardReducer from './Rewards/reducer'
import helpReducer from './Help/reducer'
import reportReducer from './Report/reducer'
import dashboardReducer from './Dashboard/reducer'
import allCoursesReducer from './AllCourses/reducer'
import discussionReducer from './Discussion/reducer'
import commentsReducer from './Comments/reducer'
import coursesOverviewReducer from './CoursesOverview/reducer'
import addWidgetReducer from './AddWidget/reducer'
import chatReducer from './Chats/reducer'
import notificationReducer from './Notifications/reducer'
import formReducer from './Forms/reducer'
import customReportsReducer from './CustomReports/reducer'
import recruitmentReducer from './Recruitment/reducer'
import slackChannelsReducer from './SlackChannels/reducer'

const rootReducer = combineReducers({
  allCourses: allCoursesReducer,
  auth: userReducer,
  commboard: commboardReducer,
  groups: groupReducer,
  courses: courseReducer,
  quizes: quizReducer,
  stores: storeReducer,
  roles: roleReducer,
  users: usersReducer,
  learningPlan: LearningPlanReducer,
  managerReport: managerReportReducer,
  employeeReport: employeeReportReducer,
  language: languageReducer,
  location: locationReducer,
  roleGroups: roleGroupsReducer,
  orgGroups: orgGroupsReducer,
  generalConfig: generalConfigReducer,
  courseConfig: courseConfigReducer,
  languageConfig: languageConfigReducer,
  themeConfig: themeConfigReducer,
  questionBank: questionBankReducer,
  externalReports: externalReportsReducer,
  checklist: checkListReducer,
  library: libraryReducer,
  rewards: rewardReducer,
  report: reportReducer,
  help: helpReducer,
  dashboard: dashboardReducer,
  discussion: discussionReducer,
  comments: commentsReducer,
  coursesOverview: coursesOverviewReducer,
  addWidget: addWidgetReducer,
  chat: chatReducer,
  notification: notificationReducer,
  form: formReducer,
  customReports: customReportsReducer,
  recruitment: recruitmentReducer,
  slackChannels: slackChannelsReducer,
})
export default rootReducer
